import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import { styled } from "@mui/material/styles";
import { useTheme } from "@mui/material/styles";
import "react-loading-skeleton/dist/skeleton.css";
import SoftTypography from "components/SoftTypography";

const SkeletonWrapper = styled("div")(() => ({
  backgroundColor: "var(--main-bg-color)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  position: "absolute",
  top: 0,
  left: 0,
  bottom: 0,
  right: 0,
  zIndex: 10
}));

export const CanvasSkeleton = () => {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";

  return (
    <SkeletonWrapper className="canvas-skeleton">
      <SkeletonTheme
        baseColor={isDark ? "#1a1a2e" : "#e0e0e0"}
        highlightColor={isDark ? "#2d2d44" : "#f5f5f5"}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center"
          }}
        >
          <Skeleton width={44} height={44} borderRadius={8} />

          <Skeleton width={2} height={40} />

          <Skeleton width={176} height={44} borderRadius={8} />

          <Skeleton width={2} height={40} />

          <div style={{ position: "relative", height: "40px", width: "360px" }}>
            <Skeleton width={360} height={2} style={{ position: "absolute", top: 0 }} />
            <Skeleton width={2} height={48} style={{ position: "absolute", top: 0, left: 0 }} />
            <Skeleton width={2} height={48} style={{ position: "absolute", top: 0, right: 0 }} />
          </div>

          <div style={{ display: "flex", gap: "180px" }}>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
              <Skeleton width={44} height={18} />
              <Skeleton width={2} height={40} />
              <Skeleton width={176} height={44} borderRadius={8} />
              <Skeleton width={2} height={40} />
              <Skeleton width={44} height={44} borderRadius={8} />
              <Skeleton width={2} height={60} />
            </div>

            <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
              <Skeleton width={44} height={18} />
              <Skeleton width={2} height={40} />
              <Skeleton width={176} height={44} borderRadius={8} />
              <Skeleton width={2} height={40} />
              <Skeleton width={44} height={44} borderRadius={8} />
              <Skeleton width={2} height={60} />
            </div>
          </div>
          <Skeleton width={360} height={2} />
          <Skeleton width={2} height={48} />

          <Skeleton width={44} height={44} borderRadius={8} />
          <SoftTypography
            sx={{ fontSize: "16px", fontWeight: 700, opacity: 0.6, marginTop: "1rem" }}
          >
            Rendering Flow...
          </SoftTypography>
        </div>
      </SkeletonTheme>
    </SkeletonWrapper>
  );
};
